import Vue from 'vue';
import VueBackbone from 'vue-backbone';

import Backbone from '@rover/globals/backbone';

import SearchAdvancedFiltersMixin from './search_advanced_filters_mixin';

const view = Object.assign(
  {
    initialize(options) {
      Vue.use(VueBackbone);
      this.filters = options.filters;
      this.serviceTypes = options.serviceTypes;

      this.initServiceSelectorDropdown('.js-search-service-selector-dropdown');
      this.initAdvancedFilters('.js-advanced-search-filters');
    },
  },
  SearchAdvancedFiltersMixin
);

export default Backbone.View.extend(view);



// WEBPACK FOOTER //
// ./js/backbone/views/search/search_sidebar_filters_view.js